import React from "react";
import { Autocomplete, Box, TextField, createFilterOptions } from "@mui/material";
import { getCountries, getCountryCallingCode } from "react-phone-number-input";
import en from "react-phone-number-input/locale/en";

// Same country list/labels as the Audience Add/Edit modals.
export const COUNTRY_CODE_OPTIONS = getCountries()
  .map((iso) => ({ iso, name: en[iso] || iso, callingCode: getCountryCallingCode(iso) }))
  .sort((a, b) => a.name.localeCompare(b.name));

const filterOptions = createFilterOptions({
  stringify: (option) => `${option.name} ${option.iso} +${option.callingCode}`,
});

// value / onChange use the ISO country ("IN"), not the calling code, since
// several countries share one (e.g. +1 for US and Canada).
const CountryCodeSelect = ({ value, onChange, label = "Country Code", size, sx }) => (
  <Autocomplete
    options={COUNTRY_CODE_OPTIONS}
    value={COUNTRY_CODE_OPTIONS.find((option) => option.iso === value) || null}
    onChange={(_, option) => option && onChange(option.iso)}
    filterOptions={filterOptions}
    getOptionLabel={(option) => (option ? `${option.name} (${option.iso}) +${option.callingCode}` : "")}
    isOptionEqualToValue={(option, selected) => option.iso === selected.iso}
    disableClearable
    size={size}
    sx={sx}
    renderOption={(props, option) => (
      <Box component="li" {...props} key={option.iso}>
        {option.name} ({option.iso}) +{option.callingCode}
      </Box>
    )}
    renderInput={(params) => <TextField {...params} label={label} />}
  />
);

export default CountryCodeSelect;
